import React, { useState, useEffect } from 'react';
import { Tabs, Tab, FormGroup, InputGroup, FormControl } from 'react-bootstrap';
import { CCLiteCommonFunc } from '../../utils/commonFunctions';
import { ValidatorCustom } from '../validator';

const FeeMultiCurrencyInput = ({
  feesByCurrencies = [],
  currencies,
  handleChange,
  validatorCallback,
  isSubmitted,
  validCases,
  name,
}) => {
  const [valid, setValid] = useState({});

  const onValidationChange = (id, isValid, messages) => {
    if (valid[id] !== isValid) {
      let newValid = {};
      setValid((prevValid) => {
        newValid = {
          ...prevValid,
          [id]: isValid,
        };
        return newValid;
      });
      if (validatorCallback) {
        validatorCallback(name, CCLiteCommonFunc.isFormValid(newValid));
      }
    }
  };

  const [localFees, setLocalFees] = useState(feesByCurrencies || []);

  const handleInputChange = (currencyISO, value) => {
    const updatedFees = localFees.map((fee) =>
      fee.currencyISO === currencyISO
        ? { ...fee, value: Number(value) || 0 }
        : fee
    );

    if (!updatedFees.some((fee) => fee.currencyISO === currencyISO)) {
      updatedFees.push({ currencyISO, value: Number(value) || 0 });
    }

    setLocalFees(updatedFees);
    handleChange(updatedFees);
  };

  useEffect(() => {
    setLocalFees(feesByCurrencies);
  }, [feesByCurrencies]);

  const checkValidForCurrency = (currencyISO) => {
    return valid?.[`currency-${currencyISO}`] === false;
  };

  return (
    <div className="input-with-validator" style={{ lineHeight: 'normal' }}>
      <Tabs
        id="currencies-tabs"
        className={`currencies-rate-tabs ${
          currencies?.length < 2 ? 'signle-currency' : ''
        }`}
        defaultActiveKey={currencies[0]?.iso}
        animation={false}
      >
        {currencies.map((currency) => {
          const currentFee = localFees?.find(
            (fee) => fee.currencyISO === currency.iso
          ) || { value: '' };

          const hasError = checkValidForCurrency(currency.iso);

          return (
            <Tab
              className={`currencies-tab-item ${hasError ? 'error-tab' : ''}`}
              eventKey={currency.iso}
              title={currency.iso}
              key={currency.iso}
            >
              <FormGroup
                className={
                  !isSubmitted
                    ? null
                    : valid[`currency-${currency.iso}`] === false
                    ? 'error'
                    : null
                }
              >
                <FormGroup className="qup-input-group">
                  <InputGroup className="single-addon-left">
                    <InputGroup.Prepend>
                      <InputGroup.Text>{currency.symbol}</InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControl
                      type="text"
                      value={currentFee.value}
                      onChange={(e) =>
                        handleInputChange(currency.iso, e.target.value)
                      }
                    />
                  </InputGroup>
                </FormGroup>
                {validCases?.length > 0 && (
                  <ValidatorCustom
                    validatorCallback={onValidationChange}
                    id={`currency-${currency.iso}`}
                    validCases={validCases}
                    isSubmitted={isSubmitted}
                    value={currentFee.value}
                  />
                )}
              </FormGroup>
            </Tab>
          );
        })}
      </Tabs>
    </div>
  );
};

export default FeeMultiCurrencyInput;
